import manifest from '../data/imageManifest.json';

export interface OptimizedImage {
  /** Path without the -1x/-2x suffix and extension, e.g. "/optimized/Books/deep-work". */
  base: string;
  fallback: 'jpg' | 'png';
  /** Dimensions of the 1x rendition. */
  width: number;
  height: number;
}

const images = manifest as Record<string, OptimizedImage>;

/** Looks up the optimized renditions generated by scripts/optimize-images.js for an original path. */
export const getOptimizedImage = (path: string): OptimizedImage | undefined => images[path];

/** URL of the 2x rendition (largest), for places that need one plain URL such as a lightbox. */
export const getLargeImageUrl = (path: string): string => {
  const optimized = getOptimizedImage(path);
  return optimized ? `${optimized.base}-2x.${optimized.fallback}` : path;
};
